// ─── Mode PiP : Picture-in-Picture vocal ──────────────────────────────────────
// Quand la mini-fenêtre Electron est ouverte, elle charge la MÊME app avec
// `?pip=1` en query. Ce module :
//   1. Détecte le flag → ajoute `pip-mode` sur <body> pour que le CSS cache
//      tout sauf le bloc dédié.
//   2. Construit un mini-affichage compact des avatars vocaux + bouton ferme.
//   3. Côté fenêtre principale : expose `detacherEnPiP()` (bouton dans le
//      bandeau vocal) qui demande à Electron d'ouvrir la mini-fenêtre.
//
// La fenêtre PiP est un client socket comme la principale (cookies partagés
// dans Electron) → elle reçoit vocal-update-global et liste-agents comme
// n'importe quel client. Pas besoin d'IPC ni de mirroring DOM.

import { socket } from './socket.js';
import { state }  from './state.js';

export function estEnModePiP() {
    try { return new URLSearchParams(location.search).has('pip'); } catch (_) { return false; }
}

function _construireLayoutPip() {
    const container = document.createElement('div');
    container.id = 'pip-container';
    container.innerHTML = `
        <div id="pip-bar">
            <span id="pip-title">🎤 Vocal</span>
            <button id="pip-close-btn" title="Fermer la mini-fenêtre">✕</button>
        </div>
        <div id="pip-participants"></div>
    `;
    document.body.appendChild(container);

    const fermer = document.getElementById('pip-close-btn');
    if (fermer) fermer.addEventListener('click', () => {
        if (window.chaosNative && window.chaosNative.fermerPiP) window.chaosNative.fermerPiP();
        else window.close();
    });
}

// ── Rendu des participants ─────────────────────────────────────────────────────

let _derniersEtats = {};

function _rendrePipParticipants(allVocalStates) {
    _derniersEtats = allVocalStates || {};

    const dest    = document.getElementById('pip-participants');
    const titleEl = document.getElementById('pip-title');
    if (!dest) return;

    const salonId  = localStorage.getItem('memoireVocalId');
    const salonNom = localStorage.getItem('memoireVocalNom');

    if (titleEl) titleEl.textContent = salonNom ? `🎤 ${salonNom}` : '🎤 Vocal';

    const membres = salonId ? (_derniersEtats[salonId] || []) : [];

    if (!salonId || membres.length === 0) {
        dest.innerHTML = '<p class="pip-empty">Aucun vocal actif.</p>';
        return;
    }

    dest.innerHTML = '';
    membres.forEach(pseudo => {
        const infos    = state.utilisateurs[pseudo] || {};
        const couleur  = infos.couleur || '#ffb75e';
        const nom      = infos.nom_affiche || pseudo;
        const initiale = (nom.charAt(0) || '?').toUpperCase();
        const avatarOk = infos.avatar_url && infos.avatar_url !== 'none' && String(infos.avatar_url) !== 'undefined';

        const el  = document.createElement('div');
        el.className       = 'pip-participant';
        el.dataset.pseudo  = pseudo;

        const av = document.createElement('div');
        av.className = 'pip-avatar';
        av.id = `pip-avatar-${pseudo}`;
        av.style.borderColor = couleur;
        if (avatarOk) {
            av.style.backgroundImage    = `url('${infos.avatar_url}')`;
            av.style.backgroundSize     = 'cover';
            av.style.backgroundPosition = 'center';
        } else {
            av.style.backgroundColor = couleur;
            av.textContent = initiale;
        }

        const nameEl = document.createElement('span');
        nameEl.className   = 'pip-name';
        nameEl.textContent = nom;

        el.appendChild(av);
        el.appendChild(nameEl);
        dest.appendChild(el);
    });
}

// ── Sync via events socket ────────────────────────────────────────────────────

function _activerSyncPip() {
    // Mise à jour de la liste des participants à chaque changement de vocal
    socket.on('vocal-update-global', _rendrePipParticipants);

    // Re-rendu quand les infos des agents arrivent (avatars, couleurs)
    // → utile si vocal-update-global est arrivé avant liste-agents
    socket.on('liste-agents', () => _rendrePipParticipants(_derniersEtats));

    // Rendu initial (vide tant que vocal-update-global n'est pas arrivé)
    _rendrePipParticipants({});
}

export function initModePiP() {
    if (!estEnModePiP()) return;
    document.body.classList.add('pip-mode');
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            _construireLayoutPip();
            _activerSyncPip();
        });
    } else {
        _construireLayoutPip();
        _activerSyncPip();
    }
}

// Côté fenêtre principale : ouverture du PiP au clic.
export function detacherEnPiP() {
    if (window.chaosNative && window.chaosNative.ouvrirPiP) {
        window.chaosNative.ouvrirPiP();
    }
}
